import AbstractSponsorComment from '@ui/comments/comments-views/abstract-sponsor-comment';

export default class SponsorTotoComment extends AbstractSponsorComment {
    constructor() {
        super();
        this.type = 'fortuna';
        this.data = {
            avatar: '/img/sponsors/fortuna-org.png',
            name: 'FORTUNA',
            text: '[sponsorowany]',
            linkText: 'FORTUNA',
            comment: 'Ten mecz możesz wytypować w ',
            button: false,
            buttonText: 'Typuj',
            secondText: 'To legalny bukmacher. Gra u nielegalnych firm jest zabroniona. Hazard wiąże się z ryzykiem.'
        };
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comments-views/sponsor-toto-comment.js